module.exports = __webpack_public_path__ + "img/brown-carpet-grass-06.a202501e.png";